
import Vue from 'vue'

// import jsyaml from 'js-yaml'
import data from './Data'

import Question from '../model/Question'
import Screens from '../model/Screens'


export default class ServiceAccess {

  constructor () {
    if (window.location.href.indexOf('localhost') > 0) {
      this.serviceURL = 'http://localhost:8000'
    } else {
      this.serviceURL = 'https://api.getmyvisatofrance.com'
    }
  
    this.yaml = data
    this.screens = null
    this.question = null
    this.values = {}

    console.log('New Service')
  }

  static get instance () {
    if (ServiceAccess._instance == null) {
      ServiceAccess._instance = new ServiceAccess()
    }
    return ServiceAccess._instance
  }



  loadGraph () {
    return new Promise((resolve, reject) => {
      resolve(this.yaml)
    })
  }

  // loadGraph () {
  //   return new Promise((resolve, reject) => {
  //     if (this.yaml) {
  //       console.log('Cache Yaml')
  //       resolve(this.yaml)
  //     } else {
  //       Vue.http.get('/static/workflow.yaml').then((response) => {
  //         console.log('Yaml Loaded')
  //         this.yaml = jsyaml.load(response.body)
  //         resolve(this.yaml)
  //       }, err => {
  //         console.error('Fail loading yaml: ', err)
  //         reject(err)
  //       })
  //     }
  //   })
  // }


  loadScreens () {
    return new Promise((resolve, reject) => {
      if (this.screens) {
        resolve(this.screens)
      } else {
        this.loadGraph().then((obj) => {
          this.screens = new Screens(obj.screens)
          resolve(this.screens)
        }, err => {
          console.error('Fail loading screens: ', err)
          reject(err)
        })
      } //if else
    }) // promise
  }

  loadErrorMessages () {
    return new Promise((resolve, reject) => {
      if (this.errorMessages) {
        resolve(this.errorMessages)
      } else {
        this.loadGraph().then((obj) => {
          this.errorMessages = obj.default['error-messages']
          resolve(this.errorMessages)
        }, err => {
          console.error('Fail loading messages: ', err)
          reject(err)
        })
      } //if else
    }) // promise
  }

  loadQuestions () {
    return new Promise((resolve, reject) => {
      if (this.questions) {
        resolve(this.questions)
      } else {
        this.loadGraph().then((obj) => {
          this.questions = {}
          for (let q of obj.questions) {
            this.questions[q.id] = new Question(q)
          }
          // build dependency
          for (let qid1 in this.questions) {
            for (let qid2 in this.questions) {
              if (this.questions[qid2].dependsOn(qid1)) {
                this.questions[qid1].addDependency(qid2)
              } 
            }
          }

          resolve(this.questions)
        }, err => {
          console.error('Fail loading questions: ', err)
          reject(err)
        })
      } //if else
    }) // promise
  }




  track (sessionId, eventName, properties) {
    let url = this.serviceURL + '/track/' + sessionId + '/' + eventName
    Vue.http.post(url, properties).then((response) => {
    }, err => {
      console.error('Track Error: ', err)
    })
  }




  storeValues (sessionId, values) {
    let url = this.serviceURL + '/values/' + sessionId
    Vue.http.post(url, values).then((response) => {})
  }
  loadValues (sessionId) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/values/' + sessionId
      Vue.http.get(url).then(response => {
        for (let key in response.body) {
          Vue.set(this.values, key, response.body[key])
        }
        // this.values = Object.assign(this.values, response.body)
        resolve(this.values)
      }, err => {
        reject(err)
      })
    })
  }

  loadStage (sessionId) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/stage/' + sessionId
      Vue.http.get(url).then(response => {
        resolve(response.body)
      }, err => {
        reject(err)
      })

    })
  }

  saveUserCase (sessionId, values) {
    let url = this.serviceURL + '/save/' + sessionId
    Vue.http.post(url, values).then((response) => {})
  }

  purchases (sessionId) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/purchases/' + sessionId
      Vue.http.get(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
  }

  fetchCouponAmount (coupon, product) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/coupon-amount/' + coupon + '?product=' + product
      Vue.http.get(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
    
  }

  checkout (sessionId, params) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/checkout/' + sessionId
      Vue.http.post(url, params).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
  }

  checkoutFriendURL (sessionId) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/checkout-friend-url/' + sessionId
      Vue.http.get(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })
  }

  checkoutFriend (sessionId, cart) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/checkout-friend/' + sessionId
      let body = {cart: cart}
      Vue.http.post(url, body).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
  }

  checkoutWire (sessionId, medium, cart) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/checkout-wire/' + sessionId
      let body = {medium: medium, cart: cart}
      Vue.http.post(url, body).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
  }

  confirmFileReview (sessionId, sign, filename) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/confirm/' + sessionId + '/' + sign + '/' + filename
      Vue.http.post(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })      
  }

  convertAsciiDoc (sessionId, sign, filename) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/convert/' + sessionId + '/' + sign + '/' + filename
      Vue.http.put(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })      
  }

  convertFileSigned (sessionId, sign, targetFileName, file, fileProgressCallback) {
    return this._storeFile('/convert/' + sessionId + '/' + sign + '/' + targetFileName, file, fileProgressCallback)
  }
  storeFile (sessionId, file, fileProgressCallback) {
    return this._storeFile('/file/' + sessionId, file, fileProgressCallback)
  }

  _storeFile (path, file, fileProgressCallback) {
    let form = new global.FormData()
    
    try {
      form.append('Content-Type', file.type || 'application/octet-stream')
      form.append('file', file)
    } catch (err) {
      console.error('Error on file upload: ', err)
    }

    return new Promise(function (resolve, reject) {
    
      let xhr = new global.XMLHttpRequest()
      xhr.timeout = 5 * 60 * 1000 // time in milliseconds

      if (fileProgressCallback) {
        xhr.upload.addEventListener('progress', function (e) { fileProgressCallback(file, e) }, false)
      }

      xhr.onreadystatechange = function () {
        if (xhr.readyState < 4) {
          return
        }
        if (xhr.status < 400) {
          try {
            let res = JSON.parse(xhr.responseText)
            resolve(res)
          } catch (err) {
            reject(err)  
          }
        } else {
          window.alert('ERROR status: ' + xhr.status + '\n' + xhr.responseText)
          let err = JSON.parse(xhr.responseText)
          err.status = xhr.status
          err.statusText = xhr.statusText
          reject(err)
        }
      }

     
      xhr.onerror = function () {
        reject(JSON.parse(xhr.responseText))
      }

      xhr.open('POST', ServiceAccess.instance.serviceURL + path, true)
      xhr.send(form)

    })

  }


  previewURL (sessionId) {
    return this.serviceURL + '/preview/' + sessionId + '/preview.pdf'
  }


  requestReview (sessionId) {
    return new Promise((resolve, reject) => {
      let url = this.serviceURL + '/review/' + sessionId
      Vue.http.post(url).then((response) => {
        resolve(response.body)
      }, err => {
        reject(err)
      })
    })    
  }


}



// WEBPACK FOOTER //
// ./src/service/ServiceAccess.js